import { t } from '@/shared/lib/i18n'
import { cn } from '@/shared/lib/utils'

interface PasswordPolicyHintsProps {
  id?: string
  className?: string
}

const PasswordPolicyHints = ({ id = 'password-hints', className }: PasswordPolicyHintsProps) => (
  <ul
    id={id}
    aria-label={t('auth.passwordPolicy.title')}
    className={cn('mt-2 list-inside list-disc space-y-1 text-xs text-muted-foreground', className)}
  >
    <li>{t('auth.passwordPolicy.policyLength')}</li>
    <li>{t('auth.passwordPolicy.policyUppercase')}</li>
    <li>{t('auth.passwordPolicy.policyLowercase')}</li>
    <li>{t('auth.passwordPolicy.policyNumber')}</li>
    <li>{t('auth.passwordPolicy.policySymbol')}</li>
  </ul>
)

export { PasswordPolicyHints }
